/** Default delay for API call. Use this for example with useDebounce hook. */
const DEBOUNCE_DELAY = 700

export { DEBOUNCE_DELAY }
